import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';

// Suppress benign ResizeObserver loop error triggered by Ant Design components
window.addEventListener('error', (e) => {
  if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
    e.stopImmediatePropagation();
  }
});

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);
